import { STATIC_PAGE_SLUG } from "../../types/TAppStaticPageSlug";
import { routes } from "../../router/Router";
import { Redirect } from "react-router-dom";

const Term: React.FC = () => {
  return (
    <Redirect
      to={{ pathname: routes.staticDetail.path(STATIC_PAGE_SLUG.term) }}
    />
  );
};

export default Term;
